class CartSummaryDropup extends HTMLElement {
  constructor() {
    super();
    this._onOutsideClick = this.handleOutsideClick.bind(this);
    this._onComponentClick = this.handleComponentClick.bind(this);
  }

  connectedCallback() {
    // 1. Attach listener to the component itself (Event Delegation)
    this.addEventListener('click', this._onComponentClick);

    // 2. Global Outside click
    document.addEventListener('click', this._onOutsideClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onComponentClick);
    document.removeEventListener('click', this._onOutsideClick);
  }

  handleComponentClick(e) {
    // Check if the click was on the header or something inside it
    const header = e.target.closest('.dropup-header');
    if (!header) return;

    e.preventDefault();
    e.stopPropagation();

    this.toggle();
  }

  toggle() {
    const isOpen = this.hasAttribute('open');
    const header = this.querySelector('.dropup-header');
    const content = this.querySelector('.dropup-content');

    if (isOpen) {
      this.removeAttribute('open');
      header?.setAttribute('aria-expanded', 'false');
      content?.setAttribute('aria-hidden', 'true');
    } else {
      this.setAttribute('open', '');
      header?.setAttribute('aria-expanded', 'true');
      content?.setAttribute('aria-hidden', 'false');
    }
  }

  handleOutsideClick(e) {
    if (this.hasAttribute('open') && !this.contains(e.target)) {
      this.removeAttribute('open');
      const header = this.querySelector('.dropup-header');
      const content = this.querySelector('.dropup-content');
      header?.setAttribute('aria-expanded', 'false');
      content?.setAttribute('aria-hidden', 'true');
    }
  }
}

if (!customElements.get('cart-summary-dropup')) {
  customElements.define('cart-summary-dropup', CartSummaryDropup);
}
